<template>
  <div class="asnwer-right">
  	<div class="answer-right-time">
  		<img src="../assets/img/answer-right-tim-icon.png" class="right-time-icon">
      {{countDown}}
      <!-- <a href="javascript:;" class="btn-toSub" @click="$emit('toSub')">交卷</a> -->
  	</div>
  	<div class="right-asheet">
  		<ul>
  			<li
          v-for="(item, index) in qList"
          :key="`qlist${index}`"
          :class="{'over': item.answerStatus == 2}"
          @click="$emit('QListClick', index)"
        ><a href="javascript:;" :class="{'asheet-state': item.answerStatus == 2}">{{index + 1}}</a></li>
  		</ul>
  	</div>
     <a href="javascript:;" class="btn-toSub-bottm" @click="$emit('toSub')">交卷</a>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    },
    props: {
      qList: Array,
      duration: Number
    },
    computed: {
      answered: function () {
        const answeredArr = this.$props.qList.filter(Q=>{
          return Q.answerStatus == 2
        })
        return answeredArr.length
      },
      unanswer: function () {
        const unanswerArr = this.$props.qList.filter(Q=>{
          return Q.answerStatus != 2
        })
        return unanswerArr.length
      },
      countDown: function () {
        const count = this.duration
        if (count == 0) { return '00:00'}
        return `${this.PrefixZero(parseInt(count/3600),2)}:${this.PrefixZero(parseInt(count%3600/60),2)}:${this.PrefixZero(count%60,2)}`
      },
    },
    methods: {
      PrefixZero: function (num, n) {
          return (Array(n).join(0) + num).slice(-n);
      },
    }
  }
</script>

<style scoped>

.asnwer-right{
  width: 250px;
  float: right;
  min-height: 600px;
  background-color: #fff;
  border-radius: 6px;
}
.answer-right-time{
  margin-left: 20px;
  margin-right: 20px;
  width: 210px;
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 18px;
  color: #454545;
}
.right-time-icon{
  width: 16px;
  height: 16px;
  margin-top: 19px;
  float: left;
  margin-right: 10px;

}
.right-asheet{
  width: 210px;
  margin:0 auto;
  margin-top: 20px;
}
.right-asheet ul{
  margin:0;
  padding:0;
  overflow: hidden;
}
.right-asheet ul li{
  list-style-type: none;
  float: left;
  margin-right: 12.5px;
  margin-bottom: 12.5px;
}
.right-asheet ul li:nth-child(5n) {
  margin-right:0;
  }
.right-asheet ul li a{
  width: 30px;
  height: 30px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;
  text-decoration: none;
  color: #7f7f7f;
  float: left;
  font-size: 14px;
}
.right-asheet ul li a.asheet-state{
  background:#0AAC50;
  color: #fff;
  border:1px solid #0AAC50;
}
.right-asheet ul li a:hover{
  background:#009640;
  color: #fff;
  border:1px solid #009640;
}
.btn-toSub{
   width: 100px;
   height: 32px;
   border-radius: 4px;
   border: 1px solid #0AAC50;
   color: #0AAC50;
   float: right;
   text-align: center;
   line-height: 32px;
   text-decoration: none;
   margin-top: 11px;
}
.btn-toSub:hover{
   background:#0AAC50;
   color: #fff;
 }
 .btn-toSub-bottm:hover{
   background:#0AAC50;
   color: #fff;
 }
 .btn-toSub-bottm{
   display: block;
   width: 100px;
   height: 32px;
   border-radius: 4px;
   border: 1px solid #0AAC50;
   color: #0AAC50;
   text-align: center;
   line-height: 32px;
   text-decoration: none;
   margin: 30px auto;

 }
</style>



// WEBPACK FOOTER //
// src/common/qList.vue